var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8141 10.1999L3.2821 11.4549C3.19551 11.4693 3.11425 11.5063 3.04649 11.5621C2.97873 11.618 2.92686 11.6906 2.8961 11.7729L0.299103 18.7309C0.0511033 19.3709 0.720103 19.9809 1.3341 19.6729L19.3341 10.6729C19.4585 10.6105 19.5631 10.5148 19.6362 10.3964C19.7093 10.2779 19.7481 10.1415 19.7481 10.0024C19.7481 9.8632 19.7093 9.72678 19.6362 9.60836C19.5631 9.48995 19.4585 9.39421 19.3341 9.33186L1.3341 0.331858C0.720103 0.0248581 0.0511033 0.634858 0.299103 1.27386L2.8971 8.23186C2.92786 8.31409 2.97973 8.38676 3.04749 8.44259C3.11525 8.49841 3.19651 8.53541 3.2831 8.54986L10.8151 9.80486C10.8621 9.81236 10.9049 9.83636 10.9357 9.87256C10.9666 9.90876 10.9836 9.95478 10.9836 10.0024C10.9836 10.0499 10.9666 10.096 10.9357 10.1322C10.9049 10.1684 10.8621 10.1924 10.8151 10.1999H10.8141Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSend);
export default __webpack_public_path__ + "static/media/icon-send.38a38bde45dfb7e357cae79913ae8fbc.svg";
export { ForwardRef as ReactComponent };